import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TemplateKvDetailModal, { displayValue } from '@/tiktok-platform/modules/templates/TemplateKvDetailModal';
import { formatBeijingDateTime } from '@/tiktok-platform/utils/formatBeijingDateTime';
import { fixedUi } from '@/i18n/fixedUi';

/**
 * 仓库模板详情（只读）：展示列表未展开的地址与联系人等完整信息。
 * 发货仓 / 退货仓共用。
 */
export default function WarehouseTemplateDetailModal({
  open = false,
  warehouse = null,
  onClose,
}) {
  const { t } = useTranslation('workbench');
  const name = warehouse?.name || warehouse?.warehouseName || '';
  const typeLabel = fixedUi(warehouse?.warehouseTypeLabel || warehouse?.warehouseType || '') || t('warehouseLib.library');
  const isDefault = warehouse?.isDefault === true
    ? t('returnDetail.yes')
    : (warehouse?.isDefault === false ? t('returnDetail.no') : '');

  const sections = useMemo(() => {
    if (!warehouse) return [];
    return [
      {
        key: 'basic',
        title: t('freightLib.basic'),
        rows: [
          { key: 'warehouseId', label: t('warehouseLib.colId'), value: displayValue(warehouse.warehouseId || warehouse.id) },
          { key: 'name', label: t('warehouseLib.colName'), value: displayValue(name) },
          { key: 'warehouseType', label: t('warehouseLib.colType'), value: displayValue(fixedUi(warehouse.warehouseTypeLabel || warehouse.warehouseType || '')) },
          { key: 'subType', label: t('warehouseLib.subType'), value: displayValue(fixedUi(warehouse.subTypeLabel || warehouse.subType || '')) },
          { key: 'effectStatus', label: t('warehouseLib.effect'), value: displayValue(fixedUi(warehouse.effectStatusLabel || warehouse.effectStatus || '')) },
          { key: 'isDefault', label: t('warehouseLib.defaultWh'), value: displayValue(isDefault) },
          { key: 'entityId', label: t('warehouseLib.entityId'), value: displayValue(warehouse.entityId) },
          {
            key: 'synced',
            label: t('freightLib.colSynced'),
            value: displayValue(formatBeijingDateTime(warehouse.lastSyncedAt || warehouse.updatedAt)),
          },
        ],
      },
      {
        key: 'address',
        title: t('warehouseLib.addressTitle'),
        rows: [
          { key: 'fullAddress', label: t('warehouseLib.fullAddress'), value: displayValue(warehouse.fullAddress) },
          { key: 'region', label: t('warehouseLib.region'), value: displayValue(warehouse.region || warehouse.regionCode) },
          { key: 'state', label: t('warehouseLib.state'), value: displayValue(warehouse.state) },
          { key: 'city', label: t('warehouseLib.city'), value: displayValue(warehouse.city) },
          { key: 'district', label: t('warehouseLib.district'), value: displayValue(warehouse.district) },
          { key: 'postalCode', label: t('warehouseLib.postal'), value: displayValue(warehouse.postalCode) },
          { key: 'contactPerson', label: t('warehouseLib.contact'), value: displayValue(warehouse.contactPerson) },
          { key: 'phoneNumber', label: t('warehouseLib.phone'), value: displayValue(warehouse.phoneNumber) },
        ],
      },
    ];
  }, [warehouse, name, isDefault, t]);

  return (
    <TemplateKvDetailModal
      open={open && Boolean(warehouse)}
      title={t('warehouseLib.detail')}
      subtitle={`${typeLabel} · ${displayValue(name)}`}
      sections={sections}
      onClose={onClose}
    />
  );
}
